var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-input",
      class: { invalid: _vm.invalid, "cad-symbol": _vm.currencySymbol == "C$" },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input-container",
          class: {
            "has-pwd": _vm.showPassword,
            "has-label": _vm.label,
            clear: _vm.clearable,
            "has-value": _vm.inputValue,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "label-top",
              class: { show: _vm.formFocus && _vm.placeholder },
            },
            [_vm._v(_vm._s(_vm.placeholder))]
          ),
          _vm._v(" "),
          _vm.tag === "textarea"
            ? _c(
                "textarea",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.inputValue,
                        expression: "inputValue",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "inputEle",
                    attrs: {
                      name: _vm.name,
                      "aria-label": _vm.name,
                      placeholder: _vm.showPlaceholder,
                      autocomplete: "off",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      blur: [
                        _vm.onBlur,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      focus: _vm.onFocus,
                      change: _vm.onChange,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = $event.target.value.trim()
                      },
                    },
                  },
                  "textarea",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.inputType === "number"
            ? _c(
                "input",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.inputValue,
                        expression: "inputValue",
                        modifiers: { number: true },
                      },
                    ],
                    ref: "inputEle",
                    attrs: {
                      type: "number",
                      name: _vm.name,
                      "aria-label": _vm.name,
                      placeholder: _vm.showPlaceholder,
                      maxlength: _vm.maxlength,
                      autocomplete: "off",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      blur: [
                        _vm.onBlur,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      focus: _vm.onFocus,
                      change: _vm.onChange,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputValue = _vm._n($event.target.value)
                      },
                    },
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.inputType === "dollar" || _vm.inputType === "address"
            ? _c(
                "input",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.inputValue,
                        expression: "inputValue",
                        modifiers: { trim: true },
                      },
                    ],
                    ref: "inputEle",
                    attrs: {
                      type: "text",
                      name: _vm.name,
                      "aria-label": _vm.name,
                      placeholder: _vm.showPlaceholder,
                      maxlength: _vm.maxlength,
                      autocomplete: "off",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      blur: [
                        _vm.onBlur,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      focus: _vm.onFocus,
                      change: _vm.onChange,
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputValue = $event.target.value.trim()
                        },
                        _vm.onInput,
                      ],
                    },
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              )
            : _vm.inputType === "tel"
            ? _vm.inputType === "checkbox"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputValue,
                          expression: "inputValue",
                        },
                      ],
                      ref: "inputEle",
                      attrs: {
                        name: _vm.name,
                        "aria-label": _vm.name,
                        placeholder: _vm.showPlaceholder,
                        autocomplete: "off",
                        disabled: _vm.disabled,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.inputValue)
                          ? _vm._i(_vm.inputValue, null) > -1
                          : _vm.inputValue,
                      },
                      on: {
                        input: _vm.onInput,
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        change: [
                          function ($event) {
                            var $$a = _vm.inputValue,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.inputValue = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.inputValue = $$c
                            }
                          },
                          _vm.onChange,
                        ],
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _vm.inputType === "radio"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputValue,
                          expression: "inputValue",
                        },
                      ],
                      ref: "inputEle",
                      attrs: {
                        name: _vm.name,
                        "aria-label": _vm.name,
                        placeholder: _vm.showPlaceholder,
                        autocomplete: "off",
                        disabled: _vm.disabled,
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.inputValue, null) },
                      on: {
                        input: _vm.onInput,
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        change: [
                          function ($event) {
                            _vm.inputValue = null
                          },
                          _vm.onChange,
                        ],
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inputValue,
                          expression: "inputValue",
                        },
                      ],
                      ref: "inputEle",
                      attrs: {
                        name: _vm.name,
                        "aria-label": _vm.name,
                        placeholder: _vm.showPlaceholder,
                        autocomplete: "off",
                        disabled: _vm.disabled,
                        type: _vm.inputType,
                      },
                      domProps: { value: _vm.inputValue },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.inputValue = $event.target.value
                          },
                          _vm.onInput,
                        ],
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        change: _vm.onChange,
                      },
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
            : _vm.inputType === "date"
            ? _c(
                "date-picker",
                _vm._b(
                  {
                    attrs: {
                      name: _vm.name,
                      date: _vm.inputValue,
                      type: _vm.inputType,
                      placeholder: _vm.showPlaceholder,
                      format: "yyyy/MM/dd",
                      valueFormat: "yyyy/MM/dd",
                      disabled: _vm.disabled,
                    },
                    on: {
                      "update:date": function ($event) {
                        _vm.inputValue = $event
                      },
                    },
                  },
                  "date-picker",
                  _vm.$attrs,
                  false
                )
              )
            : _c(
                "input",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.inputValue,
                        expression: "inputValue",
                        modifiers: { trim: true },
                      },
                      {
                        name: "outsideclick",
                        rawName: "v-outsideclick",
                        value: _vm.hideEmailSuggestion,
                        expression: "hideEmailSuggestion",
                      },
                    ],
                    ref: "inputEle",
                    attrs: {
                      type: _vm.inputType,
                      name: _vm.name,
                      "aria-label": _vm.name,
                      placeholder: _vm.showPlaceholder,
                      maxlength: _vm.type === "tel" ? 15 : _vm.maxlength,
                      autocomplete: "off",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.inputValue },
                    on: {
                      blur: [
                        _vm.onBlur,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      focus: _vm.onFocus,
                      input: [
                        function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.inputValue = $event.target.value.trim()
                        },
                        _vm.onInput,
                      ],
                      change: _vm.onChange,
                    },
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              ),
          _vm._v(" "),
          _vm.clearable
            ? _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.inputValue,
                    expression: "inputValue",
                  },
                ],
                staticClass: "iconfont icon-Empty",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.clear.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showPassword
            ? _c("span", {
                staticClass: "iconfont",
                class:
                  _vm.inputType === "password"
                    ? "icon-password"
                    : "icon-view-active",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.togglePasswordType.apply(null, arguments)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.label
            ? _c("div", {
                staticClass: "prompt",
                class: { "has-value": _vm.inputValue },
                domProps: { textContent: _vm._s(_vm.label) },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.inputType === "email"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.emailSuggestionShow && _vm.emailList.length,
                  expression: "emailSuggestionShow && emailList.length",
                },
              ],
              staticClass: "email-suggestion",
            },
            _vm._l(_vm.emailList, function (item) {
              return _c(
                "p",
                {
                  key: item.legalStr,
                  staticClass: "item",
                  on: {
                    click: function ($event) {
                      return _vm.clickEmailSuggestion(item.legalStr)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(item.emailStr) + "\n        "
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.invalid || (_vm.otherOption && _vm.otherOption.errorMsg),
              expression: "invalid || (otherOption && otherOption.errorMsg)",
            },
          ],
          staticClass: "mg-error",
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.errorMsg || (_vm.otherOption && _vm.otherOption.errorMsg)
              ) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }